import {computedFrom, transient} from "aurelia-framework";
import { BaseRuleConfigPlugin } from "../../../../rules/dialogs/add-rule/plugins/base-rule-config-plugin";
import { MultiSelectLookupControl } from "../../../../../../components/lookups/multi-select-lookup-control/multi-select-lookup-control";
import { LookupValue } from "../../../../../../../models/lookups/lookup.models";
import { RuleConfigBroker } from "../../../../../../../models/vetting/vetting.models";
import { ValidationRules } from "aurelia-validation";
import { Reflection } from "../../../../../../../utilities/reflection";

@transient()
export class RequirePscReview extends BaseRuleConfigPlugin {

    constructor(){
        super();
    }

    activate(model: { broker: RuleConfigBroker, isReadOnly: boolean }) {
        super.activate(model);

        this.meta.subtaskTypeMessage = null;
        this.meta.subtaskTypeId = null;

        this.addValidations();
    }
    
    addValidations() {
        ValidationRules
            .ensure<RequirePscReview, number[]>(x => x.pscInspectionIds)
            .satisfies((x, o) => {
                return (!o.pscInspectionLinkingVisible || o.pscInspectionIds.length == 0);
            })
            .withMessage("PSC Inspection not yet linked. Click on the 'Link' button to link the PSC Inspection.")
            .on(this)
    }

    attached() {
        this.meta.isManual = true;
        if (!this.meta.linkedPscInspections) {
            this.meta.linkedPscInspections = [];
        }
    }

    unlinkPscInspection(pscInspectionId: number) {
        const incs = this.meta.linkedPscInspections.filter(x => x == pscInspectionId);

        for (const i of incs) {
            const index = this.meta.linkedPscInspections.indexOf(i);
            if (index >= 0)
                this.meta.linkedPscInspections.splice(index, 1);
        }
    }

    incLookup: MultiSelectLookupControl;
    pscInspectionIds: number[] = []

    @computedFrom(Reflection.getPropertyPath<RequirePscReview>(z => z.incLookup),
        Reflection.getPropertyPath<RequirePscReview>(z => z.incLookup.itemSource),
        Reflection.getPropertyPath<RequirePscReview>(z => z.incLookup.itemSource.length),
        Reflection.getPropertyPath<RequirePscReview>(z => z.meta),
        Reflection.getPropertyPath<RequirePscReview>(z => z.meta.linkedPscInspections),
        Reflection.getPropertyPath<RequirePscReview>(z => z.meta.linkedPscInspections.length))
    get linkedPscInspections(): LookupValue[] {
        if (!this.incLookup || !this.incLookup.itemSource || !this.meta || !this.meta.linkedPscInspections)
            return [];

        return this.incLookup.itemSource.filter(x => this.meta.linkedPscInspections.indexOf(x.id) > -1);
    }

    @computedFrom(Reflection.getPropertyPath<RequirePscReview>(z => z.linkedPscInspections),
    Reflection.getPropertyPath<RequirePscReview>(z => z.linkedPscInspections.length))
    get linkedPscInspectionIds(): number[] {
        return this.linkedPscInspections.map(x => x.id);
    }

    linkToPscInspection() {
        this.pscInspectionLinkingVisible = false;
        for (const i of this.pscInspectionIds)
            this.meta.linkedPscInspections.push(i);
        this.pscInspectionIds = [];
    }

    pscInspectionLinkingVisible: boolean = false;
    showPscInspectionLinking() {
        this.pscInspectionLinkingVisible = true;
    }

    cancelPscInspectionLinking() {
        this.pscInspectionLinkingVisible = false;
        this.pscInspectionIds = [];
    }

    subtaskTypeChanged($event)
    {
        this.meta.name = $event.detail?.item?.name;
        const newItem = $event && $event.detail && $event.detail.item? $event.detail.item: null;
        const oldItem = $event && $event.detail && $event.detail.item? $event.detail.oldItem: null;
        if(newItem && 
            (!oldItem || (oldItem.id != newItem.id)))
        {
            this.meta.subtaskTypeMessage = newItem.additionalData && newItem.additionalData.template? newItem.additionalData.template: null;
        }
    }
}